// FilterPanel.tsx

import React, { useState } from "react";
import "./FilterPanel.css";
const vipDataSource = [
  {
    key: "age",
    parent: "年龄",
    childern: ["不限"],
  },
  {
    key: "major",
    parent: "专业",
    childern: [
      "不限",
      // "财会类",
      // "电子商务类",
      // "工商管理类",
      // "金融学类",
      // "经济与贸易类",
    ],
  },
  {
    key: "activeTime",
    parent: "活跃度[单选]",
    childern: [
      "不限",
      "刚刚活跃",
      "今日活跃",
      "3日内活跃",
      "本周活跃",
      "本月活跃",
    ],
  },
  {
    key: "sex",
    parent: "性别",
    childern: ["不限", "男", "女"],
  },
  {
    key: "recentlyRead",
    parent: "近期没有看过",
    childern: ["不限", "近14天没有"],
  },
  {
    key: "resumeExchanged",
    parent: "是否与同事交换简历",
    childern: ["不限", "近一个月没有"],
  },
  {
    key: "schoolLevel",
    parent: "院校",
    childern: [
      "不限",
      "985",
      "211",
      "双一流院校",
      "留学",
      "国内外名校",
      "公办本科",
      "只看第一学历（第一学历为全日制本科）",
    ],
  },
  {
    key: "jobChange",
    parent: "跳槽频率[单选]",
    childern: ["不限", "5年少于3份", "平均每份工作大于1年"],
  },
];
const dataSource = [
  {
    key: "workTime",
    parent: "经验要求",
    childern: [
      "不限",
      "在校/应届",
      "24年毕业",
      "25年毕业",
      "25年后毕业",
      "1年以内",
      "1-3年",
      "3-5年",
      "5-10年",
      "10年以上",
    ],
  },
  {
    key: "degree",
    parent: "学历要求",
    childern: [
      "不限",
      "初中及以下",
      "中专/中技",
      "高中",
      "大专",
      "本科",
      "硕士",
      "博士",
    ],
  },
  {
    key: "salary",
    parent: "薪资待遇[单选]",
    childern: [
      "不限",
      "3K以下",
      "3-5K",
      "5-10K",
      "10-20K",
      "20-50K",
      "50K以上",
    ],
  },
  {
    key: "status",
    parent: "求职意向",
    childern: [
      "不限",
      "离职-随时到岗",
      "在职-暂不考虑",
      "在职-考虑机会",
      "在职-月内到岗",
    ],
  },
];

interface Condition {
  [key: string]: any | undefined;
}

const FilterPanel = ({ condition = {} as Condition, filter = true }) => {
  console.log("FilterPanel", filter, condition);

  var vipSOurce = [...vipDataSource];
  let idx = vipSOurce.findIndex((item) => item.key === "major");
  if (idx !== -1) {
    if (condition.major && condition.major.length > 0) {
      vipSOurce[idx].childern = ["不限"].concat(condition.major);
    }
  }

  let ageIndex = vipSOurce.findIndex((item) => item.key === "age");
  if (ageIndex !== -1) {
    if (condition.highAge && condition.lowAge) {
      vipSOurce[ageIndex].childern = [
        `${condition.lowAge} ~ ${condition.highAge}`,
      ];
    }
  }

  return (
    <div className="container">
      <div className="filter-content-vip">
        {vipSOurce.map((item, index) => (
          <div key={item.key} className="filter-item">
            <div className="filter-wrap">
              <p className="name">{item.parent}</p>
              <div className="check-box">
                {item.childern.map((subItem, chlildIndex) => (
                  <div
                    key={chlildIndex}
                    className={`${
                      condition &&
                      condition[item.key] &&
                      condition[item.key]!.length > 0
                        ? condition[item.key]?.includes(subItem)
                          ? "default option vip"
                          : "default option"
                        : chlildIndex === 0
                        ? "default option vip"
                        : "default option"
                    }`}
                  >
                    {subItem}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="filter-content">
        {dataSource.map((item, index) => (
          <div key={item.key} className="filter-item">
            <div className="filter-wrap">
              <p className="name">{item.parent}</p>
              <div className="check-box">
                {item.childern.map((subItem, chlildIndex) => (
                  <div
                    key={chlildIndex}
                    className={`${
                      condition &&
                      condition[item.key] &&
                      condition[item.key]!.length > 0
                        ? condition[item.key]?.includes(subItem)
                          ? "default option active"
                          : "default option"
                        : chlildIndex === 0
                        ? "default option active"
                        : "default option"
                    }`}
                  >
                    {subItem}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {!filter && (
        <div className="lamp-image-filter">
          <div className="color-lamp-filter" style={{ paddingBottom: "10px" }}>
            <div className="lamp-filter red"></div>
            <span className="warn">
              boss端设置的筛选条件不匹配，请核对筛选条件是否一致。
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;
